import React from 'react';
import classNames from 'classnames';

export type LabelVariant = 'primary' | 'default' | 'disabled';

type CommonProps = {
  className?: string;
  hasError?: boolean;
  bold?: boolean;
  id?: string;
  variant?: LabelVariant;
  showRequiredIndicator?: boolean;
};

type LabelProps = CommonProps & {
  as?: 'label';
  htmlFor?: string;
};

type LegendProps = CommonProps & {
  as: 'legend';
};

type Props = LabelProps | LegendProps;

export const Label: React.FC<Props> = (props) => {
  const {
    as: Component = 'label',
    hasError,
    className,
    bold = true,
    variant = 'primary',
    showRequiredIndicator,
    children,
    ...rest
  } = props;
  const getTextClassName = () => {
    if (hasError) {
      return 'text-red-500';
    } else if (variant === 'primary') {
      return 'text-primary-500';
    } else if (variant === 'disabled') {
      return 'text-primary-200';
    } else {
      return null;
    }
  };

  return (
    <>
      <Component
        className={classNames(
          Boolean(children) && 'inline-block',
          'text-sm',
          { 'font-medium': bold },
          getTextClassName(),
          className
        )}
        {...rest}
      >
        {children}
      </Component>
      {showRequiredIndicator && <span className="text-red-500 ml-1">*</span>}
    </>
  );
};
